import r2wc from '@r2wc/react-to-web-component';
import '@webcomponents/custom-elements';
import MyJourneysModalWidget from '../widgets/MyJourneysModalWidget';

const WebMyJourneysModalWidget = r2wc(MyJourneysModalWidget, {
  props: {
    thgConfig: 'json',
    configOverrides: 'json',
    myJourneysUrl: 'string',
    widgetSessionKeyPrefix: 'string'
  }
});

customElements.get('thg-my-journeys-modal') ||
  customElements.define('thg-my-journeys-modal', WebMyJourneysModalWidget);
